export * from './page-authenticator.component';
